(function () {
  const BlendQuiz = window.BlendQuiz = window.BlendQuiz || {};

  // Persist one answer as user selects it (so line-item props are always available)
  BlendQuiz.persistAnswer = function (step, qData, label, idx) {
    try {
      const existing = window.quizStateManager?.get?.('quizAnswers');
      const arr = Array.isArray(existing) ? existing : [];
      arr[step] = { question: qData.question, answer: label, index: idx };
      window.quizStateManager?.set?.('quizAnswers', arr);
    } catch {}
  };
})();
